"use strict";function debounce(n,i){void 0===i&&(i=0);function u(){d&&(clearTimeout(d),d=void 0)}var d=void 0;return[function(){for(var e=this,o=[],t=0;t<arguments.length;t++)o[t]=arguments[t];u(),d=window.setTimeout(function(){n.apply(e,o),d=void 0},i)},u]}Object.defineProperty(exports,"__esModule",{value:!0}),exports.debounce=void 0,exports.debounce=debounce;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-alice-carousel/lib/utils/timers.js
// module id = 1045
// module chunks = 0